import moment from 'moment';

export const createListOfYears = (firstYear, lastYear) => {
  const sub = lastYear - firstYear;
  const years = [{
    name: String(firstYear),
    id: String(firstYear)
  }];
  if (sub > 1) {
    for (let i = 1; i <= sub; i += 1) {
      years.push({
        name: String(firstYear + i),
        id: String(firstYear + i)
      });
    }
  } else {
    years.push({
      name: String(lastYear),
      id: String(lastYear),
    });
  }
  return years;
};

export const getNormalizeData = (data) => {
  const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  const firstYear = moment(data[0].col_year).year();
  const lastYear = moment(data[data.length - 1].col_year).year();
  const arrayOfYears = createListOfYears(Number(firstYear), Number(lastYear));
  let allData = {};
  arrayOfYears.forEach((item) => {
    allData = {
      ...allData,
      [item.name]: []
    };
    months.forEach((month, id) => {
      if (month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') {
        const tempYear = allData[item.name];
        tempYear[id + 1] = data.filter((it) => moment(it.sched_dt).isBetween(`${item.name}-${month}-01`, `${item.name}-${month}-31`, undefined, '[]'));
        allData[item.name] = tempYear;
      } else if (month === '02') {
        const tempYear = allData[item.name];
        tempYear[id + 1] = data.filter((it) => moment(it.sched_dt).isBetween(`${item.name}-${month}-01`, `${item.name}-${month}-29`, undefined, '[]'));
        allData[item.name] = tempYear;
      } else {
        const tempYear = allData[item.name];
        tempYear[id + 1] = data.filter((it) => moment(it.sched_dt).isBetween(`${item.name}-${month}-01`, `${item.name}-${month}-30`, undefined, '[]'));
        allData[item.name] = tempYear;
      }
    });
  });
  return { allData, arrayOfYears };
};
